var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStaffingFlexibility({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 241,
    height: 170,
    viewBox: "0 0 241 170",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M206.37 169.472L239.77 86.0824C240.89 83.2924 239.54 80.1224 236.74 79.0024L40.48 0.392404C37.69 -0.727596 34.52 0.632404 33.4 3.4224L0 86.8124L206.37 169.472Z",
    fill: "#E8E8E8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0226 56.7138L15.0698 66.5815L39.4653 76.3539L43.4181 66.4861L19.0226 56.7138Z",
    fill: "#C1C1C1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8317 69.666L9.87891 79.5337L19.7466 83.4865L23.6994 73.6188L13.8317 69.666Z",
    fill: "#C1C1C1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8898 74.497L21.937 84.3647L31.8048 88.3176L35.7576 78.4498L25.8898 74.497Z",
    fill: "#C1C1C1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9479 79.3281L33.9951 89.1958L43.8629 93.1486L47.8157 83.2809L37.9479 79.3281Z",
    fill: "#C1C1C1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0163 84.1689L46.0635 94.0366L55.9312 97.9894L59.884 88.1217L50.0163 84.1689Z",
    fill: "#C1C1C1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M136.365 118.763L132.413 128.631L142.28 132.584L146.233 122.716L136.365 118.763Z",
    fill: "#C1C1C1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M148.299 123.536L144.346 133.404L154.214 137.357L158.167 127.489L148.299 123.536Z",
    fill: "#C1C1C1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M160.233 128.309L156.28 138.177L166.148 142.13L170.1 132.262L160.233 128.309Z",
    fill: "#C1C1C1"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M172.143 133.088L168.19 142.956L178.058 146.908L182.01 137.041L172.143 133.088Z",
    fill: "#C1C1C1"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M184.486 138.033L180.534 147.901L190.401 151.854L194.354 141.986L184.486 138.033Z",
    fill: "#C1C1C1"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M196.82 142.968L192.868 152.835L204.796 157.614L208.749 147.746L196.82 142.968Z",
    fill: "#C1C1C1"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M62.0851 88.9936L58.1323 98.8613L130.372 127.799L134.325 117.931L62.0851 88.9936Z",
    fill: "#C1C1C1"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6603 10.1744L35.0796 16.6167L44.9473 20.5695L47.528 14.1272L37.6603 10.1744Z",
    fill: "#C1C1C1"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M49.7926 15.0415L47.2119 21.4839L57.0796 25.4367L59.6603 18.9944L49.7926 15.0415Z",
    fill: "#C1C1C1"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M61.9244 19.8985L59.3438 26.3408L69.2115 30.2936L71.7922 23.8513L61.9244 19.8985Z",
    fill: "#C1C1C1"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M74.0567 24.7554L71.4761 31.1978L81.3438 35.1506L83.9245 28.7082L74.0567 24.7554Z",
    fill: "#C1C1C1"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M87.421 30.1128L84.8403 36.5552L94.7081 40.508L97.2887 34.0656L87.421 30.1128Z",
    fill: "#C1C1C1"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M99.5533 34.9698L96.9727 41.4121L106.84 45.3649L109.421 38.9226L99.5533 34.9698Z",
    fill: "#C1C1C1"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M111.685 39.837L109.104 46.2793L118.972 50.2321L121.553 43.7898L111.685 39.837Z",
    fill: "#C1C1C1"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M123.817 44.6939L121.237 51.1362L131.105 55.089L133.685 48.6467L123.817 44.6939Z",
    fill: "#C1C1C1"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M136.765 49.8697L134.184 56.312L144.052 60.2648L146.632 53.8225L136.765 49.8697Z",
    fill: "#C1C1C1"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M148.897 54.7369L146.316 61.1792L156.184 65.132L158.765 58.6897L148.897 54.7369Z",
    fill: "#C1C1C1"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M161.029 59.5938L158.448 66.0361L168.316 69.9889L170.897 63.5466L161.029 59.5938Z",
    fill: "#C1C1C1"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M173.161 64.4605L170.581 70.9028L180.448 74.8556L183.029 68.4133L173.161 64.4605Z",
    fill: "#C1C1C1"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M186.144 69.8502L183.563 76.2925L193.431 80.2453L196.012 73.803L186.144 69.8502Z",
    fill: "#C1C1C1"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M198.276 74.7173L195.695 81.1597L205.563 85.1125L208.144 78.6701L198.276 74.7173Z",
    fill: "#C1C1C1"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M210.408 79.5743L207.828 86.0166L217.695 89.9694L220.276 83.5271L210.408 79.5743Z",
    fill: "#C1C1C1"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M222.541 84.4312L219.96 90.8735L229.828 94.8263L232.408 88.384L222.541 84.4312Z",
    fill: "#C1C1C1"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2189 43.7656L20.2661 53.6333L39.1847 61.2117L43.1375 51.3439L24.2189 43.7656Z",
    fill: "#C1C1C1"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5612 52.3193L41.6084 62.187L51.4761 66.1398L55.4289 56.2721L45.5612 52.3193Z",
    fill: "#C1C1C1"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1286 67.5746L42.1758 77.4424L52.0435 81.3952L55.9963 71.5275L46.1286 67.5746Z",
    fill: "#C1C1C1"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0529 72.3437L54.1001 82.2114L63.9678 86.1642L67.9206 76.2965L58.0529 72.3437Z",
    fill: "#C1C1C1"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M69.9826 77.1357L66.0298 87.0034L75.8975 90.9562L79.8503 81.0885L69.9826 77.1357Z",
    fill: "#C1C1C1"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M81.9059 81.9086L77.9531 91.7764L87.8209 95.7292L91.7737 85.8614L81.9059 81.9086Z",
    fill: "#C1C1C1"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M93.8263 86.6874L89.8735 96.5552L99.7413 100.508L103.694 90.6403L93.8263 86.6874Z",
    fill: "#C1C1C1"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M105.76 91.4604L101.807 101.328L111.675 105.281L115.628 95.4132L105.76 91.4604Z",
    fill: "#C1C1C1"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M117.68 96.2426L113.727 106.11L123.595 110.063L127.548 100.195L117.68 96.2426Z",
    fill: "#C1C1C1"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M129.604 101.012L125.651 110.879L135.519 114.832L139.471 104.964L129.604 101.012Z",
    fill: "#C1C1C1"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M141.534 105.794L137.581 115.662L147.449 119.614L151.402 109.747L141.534 105.794Z",
    fill: "#C1C1C1"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M153.457 110.567L149.504 120.435L159.372 124.387L163.325 114.52L153.457 110.567Z",
    fill: "#C1C1C1"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M165.387 115.349L161.434 125.217L171.302 129.17L175.255 119.302L165.387 115.349Z",
    fill: "#C1C1C1"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M177.307 120.125L173.354 129.993L209.957 144.655L213.91 134.787L177.307 120.125Z",
    fill: "#C1C1C1"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M57.485 57.0883L53.5322 66.9561L63.4 70.9089L67.3528 61.0411L57.485 57.0883Z",
    fill: "#C1C1C1"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M69.405 61.8705L65.4521 71.7383L75.3199 75.6911L79.2727 65.8234L69.405 61.8705Z",
    fill: "#C1C1C1"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M81.3385 66.6435L77.3857 76.5112L87.2535 80.464L91.2063 70.5963L81.3385 66.6435Z",
    fill: "#C1C1C1"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M93.259 71.4218L89.3062 81.2896L99.1739 85.2424L103.127 75.3746L93.259 71.4218Z",
    fill: "#C1C1C1"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M105.182 76.1948L101.229 86.0625L111.097 90.0153L115.05 80.1476L105.182 76.1948Z",
    fill: "#C1C1C1"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M117.112 80.9872L113.159 90.855L123.027 94.8078L126.98 84.9401L117.112 80.9872Z",
    fill: "#C1C1C1"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M129.036 85.7563L125.083 95.624L134.951 99.5768L138.904 89.7091L129.036 85.7563Z",
    fill: "#C1C1C1"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M140.956 90.5385L137.003 100.406L146.871 104.359L150.823 94.4913L140.956 90.5385Z",
    fill: "#C1C1C1"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M152.889 95.3115L148.937 105.179L158.804 109.132L162.757 99.2643L152.889 95.3115Z",
    fill: "#C1C1C1"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M164.814 100.081L160.861 109.949L170.729 113.902L174.681 104.034L164.814 100.081Z",
    fill: "#C1C1C1"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M176.743 104.863L172.791 114.731L182.658 118.684L186.611 108.816L176.743 104.863Z",
    fill: "#C1C1C1"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M188.669 109.635L184.716 119.503L215.145 131.692L219.098 121.825L188.669 109.635Z",
    fill: "#C1C1C1"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4035 30.8095L25.4507 40.6772L41.3523 47.0471L45.3051 37.1794L29.4035 30.8095Z",
    fill: "#C1C1C1"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7673 38.1655L43.8145 48.0332L53.6822 51.986L57.635 42.1183L47.7673 38.1655Z",
    fill: "#C1C1C1"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0983 43.1166L56.1455 52.9844L66.0132 56.9372L69.9661 47.0694L60.0983 43.1166Z",
    fill: "#C1C1C1"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M72.4323 48.0488L68.4795 57.9165L78.3472 61.8693L82.3 52.0016L72.4323 48.0488Z",
    fill: "#C1C1C1"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M84.777 52.9907L80.8242 62.8584L90.692 66.8112L94.6448 56.9435L84.777 52.9907Z",
    fill: "#C1C1C1"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M97.1076 57.9316L93.1548 67.7993L103.023 71.7521L106.975 61.8844L97.1076 57.9316Z",
    fill: "#C1C1C1"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M109.451 62.8774L105.499 72.7451L115.366 76.6979L119.319 66.8302L109.451 62.8774Z",
    fill: "#C1C1C1"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M121.773 67.8149L117.82 77.6826L127.688 81.6354L131.64 71.7677L121.773 67.8149Z",
    fill: "#C1C1C1"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M134.116 72.7602L130.164 82.6279L140.031 86.5807L143.984 76.713L134.116 72.7602Z",
    fill: "#C1C1C1"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M146.457 77.7016L142.504 87.5693L152.372 91.5221L156.325 81.6544L146.457 77.7016Z",
    fill: "#C1C1C1"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M158.792 82.643L154.839 92.5107L164.707 96.4635L168.659 86.5958L158.792 82.643Z",
    fill: "#C1C1C1"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M171.122 87.5844L167.169 97.4521L177.037 101.405L180.99 91.5372L171.122 87.5844Z",
    fill: "#C1C1C1"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M183.457 92.5263L179.504 102.394L189.372 106.347L193.324 96.4791L183.457 92.5263Z",
    fill: "#C1C1C1"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M195.791 97.4579L191.838 107.326L201.706 111.278L205.659 101.411L195.791 97.4579Z",
    fill: "#C1C1C1"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M208.126 102.413L204.173 112.281L220.353 118.762L224.306 108.894L208.126 102.413Z",
    fill: "#C1C1C1"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M194.591 83.0268L190.639 92.8945L212.574 101.681L216.527 91.8137L194.591 83.0268Z",
    fill: "#C1C1C1"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2184 18.7875L30.2656 28.6553L40.1334 32.6081L44.0862 22.7403L34.2184 18.7875Z",
    fill: "#C1C1C1"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5534 23.7158L42.6006 33.5835L52.4683 37.5363L56.4211 27.6686L46.5534 23.7158Z",
    fill: "#C1C1C1"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M58.8937 28.6703L54.9409 38.5381L64.8087 42.4909L68.7615 32.6232L58.8937 28.6703Z",
    fill: "#C1C1C1"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2282 33.6122L67.2754 43.48L77.1431 47.4328L81.0959 37.5651L71.2282 33.6122Z",
    fill: "#C1C1C1"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M83.5588 38.5536L79.606 48.4214L89.4737 52.3742L93.4265 42.5065L83.5588 38.5536Z",
    fill: "#C1C1C1"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M95.8932 43.4955L91.9404 53.3633L101.808 57.3161L105.761 47.4484L95.8932 43.4955Z",
    fill: "#C1C1C1"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M108.237 48.4272L104.285 58.2949L114.152 62.2477L118.105 52.38L108.237 48.4272Z",
    fill: "#C1C1C1"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M120.569 53.3784L116.616 63.2461L126.483 67.1989L130.436 57.3312L120.569 53.3784Z",
    fill: "#C1C1C1"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M132.903 58.31L128.95 68.1777L138.818 72.1305L142.771 62.2628L132.903 58.31Z",
    fill: "#C1C1C1"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M145.246 63.2558L141.293 73.1235L151.161 77.0763L155.114 67.2086L145.246 63.2558Z",
    fill: "#C1C1C1"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M157.587 68.1967L153.634 78.0645L163.502 82.0173L167.455 72.1495L157.587 68.1967Z",
    fill: "#C1C1C1"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M169.922 73.1386L165.969 83.0063L175.836 86.9592L179.789 77.0914L169.922 73.1386Z",
    fill: "#C1C1C1"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M182.256 78.0805L178.303 87.9482L188.171 91.9011L192.124 82.0333L182.256 78.0805Z",
    fill: "#C1C1C1"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M219.266 92.9052L215.313 102.773L225.181 106.726L229.134 96.858L219.266 92.9052Z",
    fill: "#C1C1C1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStaffingFlexibility);
export default __webpack_public_path__ + "static/media/staffing-flexibility.87cc970d928c2c46e9db0afb523b86b3.svg";
export { ForwardRef as ReactComponent };